import { Box, Button, Modal } from '@palmetto/palmetto-components';

interface ArchiveStandardHoldbackModalProps {
  state: string;
  isOpen: boolean;
  handleClose: () => void;
  onConfirmArchive: () => void;
  isLoading?: boolean;
}

export const ArchiveStandardHoldbackModal = ({
  state,
  isOpen,
  handleClose,
  onConfirmArchive,
  isLoading = false,
}: ArchiveStandardHoldbackModalProps) => {
  const archiveHoldbackText = `There will not be a holdback for ${state}. I understand and agree that any changes made to holdbacks will apply to accounts that receive a quote following any holdback change. Any account that has already had a contract sent will not be impacted.`;
  return (
    <Modal
      isOpen={isOpen}
      maxWidth="4xl"
      ariaLabelledBy="archiveStandardHoldbackModal"
      onDismiss={() => {
        handleClose();
      }}
    >
      <Modal.Header
        id="archiveStandardHoldbackModal"
        title={`Archive ${state} Holdback`}
        onDismiss={() => {
          handleClose();
        }}
      />
      <Modal.Body background="secondary">
        <Box>{archiveHoldbackText}</Box>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          tone="neutral"
          isDisabled={isLoading}
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button variant="primary" type="submit" tone="danger" isDisabled={isLoading} onClick={onConfirmArchive}>
          Archive
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
